import { CircularProgress, Paper, Typography } from "@mui/material";
import { BarChart } from '@mui/x-charts/BarChart';
import { DefaultColorsDashboard } from "./DefaultColorsDashboard";
import { ChartsAPI } from "../api/ChartsAPI";
import { useEffect, useState, useCallback } from "react";
import { Box } from "@mui/system";
import { Bar } from 'react-chartjs-2';
import { formatBRL } from "./utils/format";

export const DashboardTopPets = ({ startDate = null, endDate = null }) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const loadData = useCallback(async () => {
        setLoading(true);
        const response = await ChartsAPI.getTopPets(startDate, endDate);
        if (response.success) {
            setData(response.data.result);
        }
        setLoading(false);
    }, [startDate, endDate]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const chartData = {
        labels: data.map((item) => item.dataLabel),
        datasets: [
            {
                label: 'Atendimentos',
                data: data.map((item) => item.value),
                backgroundColor: DefaultColorsDashboard,
                borderWidth: 1,
                borderRadius: 4,
                borderSkipped: false,
                animation: {
                    duration: 1000
                },
            },
        ],
    };

    const options = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 10,
                right: 20,
                top: 10,
                bottom: 10,
            },
        },

        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                font: {
                    size: 18,
                },
                padding: {
                    top: 10,
                    bottom: 30,
                },
            },
            tooltip: {
            },
        },
        scales: {
            x: {
                beginAtZero: true,

            },
            y: {
                grid: {
                    display: false,
                },
            },
        },
    };

    const colors = DefaultColorsDashboard;

    return (
        <Paper elevation={1} sx={{ padding: 3, width: '100%' }}>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%" width="100%" >
                    <CircularProgress />
                </Box>
            ) : (
                data.length > 0 ? (
                    <>
                        <Typography variant="h6">Pets Mais Atendidos</Typography>
                        <Box sx={{ width: '100%', height: '400px', minHeight: '300px' }}>
                            <Bar data={chartData} options={options} />
                        </Box>
                    </>
                ) : (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%" width="100%" >
                        <Typography variant="h6" color="text.secondary">Nenhum dado encontrado para Pets Mais Atendidos</Typography>
                    </Box>
                ))}

        </Paper>
    );
}